/* 语音消息队列 */
export default class AudioQueue {
    constructor() {
        this.list = []
        this.index = 0
    }

    /* 向队列添加语音任务 */
    add(...fn) {
        this.list.push(...fn)
    }

    /* 执行语音任务 */
    run() {
        const curFn = this.list[this.index]
        curFn(this.next)
    }

    /* 下一个语音任务 */
    next() {
        if (this.index >= this.list.length - 1) {
            this.clear()
            return false
        }
        const curFn = this.list[++this.index]
        curFn(this.next)
    }

    /* 清空队列 */
    clear() {
        this.list = []
        this.index = 0
    }

    /* 判断队列是否为空 */
    get isEmpty() {
        return !this.list.length && !this.index
    }
}


// WEBPACK FOOTER //
// ./src/assets/js/audio/queue.js